import styles from "./hero-banner-one.module.css";
import { useState, useCallback, useEffect } from "react";
import { ProjectTemplate } from "PosterEditor/model/project-template";
import { useTemplateStore } from "entity-store/template-store/use-template-store";
import { TemplateCollection } from "PosterEditor/model/template-collection";
import { TemplatePreview } from "components/common/template-preview";

interface HeroBannerVariantOneProps {
  collection: TemplateCollection;
  onClickTemplate: (template: ProjectTemplate) => void;
}

export const HeroBannerVariantOne = (props: HeroBannerVariantOneProps) => {
  const { loadTemplatesByIDs } = useTemplateStore();
  const [titleTemplates, setTitleTemplates] = useState<ProjectTemplate[]>([]);

  const load = useCallback(() => {
    loadTemplatesByIDs(props.collection.templateIDs).then(setTitleTemplates);
  }, [loadTemplatesByIDs, props.collection.templateIDs]);

  useEffect(() => {
    load();
  }, [load]);
  return (
    <div
      className={styles.heroBannerContainer}
      style={{ backgroundImage: `url("/backgrounds/wall-background-1.png")` }}
    >
      {titleTemplates.map((template) => (
        <button
          className={styles.template}
          onClick={() => {
            props.onClickTemplate(template);
          }}
        >
          <TemplatePreview
            key={template.id}
            template={template}
            size={{ width: 300, height: 300 }}
          />
        </button>
      ))}
    </div>
  );
};
